import { FC } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { KeycloakLogin } from "@Pages/Login/KeycloakLogin";
import { AuthorizationError } from "@Pages/AuthorizationError";
import { Logout } from "@Pages/Logout";

export const UnauthenticatedRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<KeycloakLogin />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/authorization-error" element={<AuthorizationError />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};
